import type { Framework } from '@toeverything/infra';

import { AccessibleDocCacheStore } from '../doc/stores/accessible-doc-cache';
import { WorkspaceAreaCacheStore } from '../folder-api/stores/workspace-area-cache';
import { AccessibleFolderCacheStore } from '../organize/stores/accessible-folder-cache';
import { TagStore } from '../tag/stores/tag';
import { WorkspaceScope } from '../workspace/scopes/workspace';
import { WorkspaceService } from '../workspace/services/workspace';
import { WorkspacesService } from '../workspace/services/workspaces';
import { WorkspaceProjectionReconciler } from './workspace-projection-reconciler';

export { WorkspaceProjectionReconciler } from './workspace-projection-reconciler';

export function configureWorkspaceProjectionReconciliationModule(
  framework: Framework
): void {
  framework
    .scope(WorkspaceScope)
    .service(WorkspaceProjectionReconciler, [
      WorkspaceService,
      WorkspacesService,
      AccessibleDocCacheStore,
      AccessibleFolderCacheStore,
      WorkspaceAreaCacheStore,
      TagStore,
    ]);
}
